import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import {
  checkIsModuleAction,
  MODULE_REGISTRY,
  SupportedModule,
} from '../../moduleRegistry'

export function useModuleAction<M extends SupportedModule>(module: M) {
  const [searchParams, setSearchParams] = useSearchParams()
  const actionParam = searchParams.get('action')

  const isValidAction =
    typeof actionParam === 'string' && checkIsModuleAction(module, actionParam)

  const selectedAction = isValidAction
    ? (actionParam as keyof (typeof MODULE_REGISTRY)[M]['actions'])
    : null

  useEffect(() => {
    if (actionParam && !isValidAction) {
      const currentModule = searchParams.get('module')
      setSearchParams({ module: currentModule ?? module })
    }
  }, [module, actionParam, isValidAction, searchParams, setSearchParams])

  const selectAction = (action: string) => {
    const currentModule = searchParams.get('module')
    setSearchParams({ module: currentModule ?? module, action })
  }

  return {
    selectedAction,
    selectAction,
    isValidAction,
  }
}
